import BugsnagPerformance from '@bugsnag/browser-performance'
import { VueRouterRoutingProvider } from '@bugsnag/vue-router-performance'
import packageJSON from '../../package.json'

import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router'
import routes from './routes'

export default function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history' ? createWebHistory : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.config.js instead!
    // quasar.config.js -> build -> vueRouterMode
    // quasar.config.js -> build -> publicPath
    history: createHistory(process.env.MODE === 'ssr' ? void 0 : process.env.VUE_ROUTER_BASE)
  })

  setBugsnag(Router)

  return Router
}
/**
 * Configura o Bugsnag para monitoramento de performance e erros, usado em conjunto com Vue Router.
 *
 * @see https://docs.bugsnag.com/performance/integration-guides/web/#sending-custom-spans
 * @see https://docs.bugsnag.com/performance/integration-guides/web/customizing-routes/vue-router/
 *
 * @param {import('vue-router').Router} router - Instância do roteador Vue.
 */
function setBugsnag (router) {
  // necessário mapear os ambientes para os valores configurados no Bugsnag
  const mappedReleaseStage = {
    production: 'production',
    temporary: 'release',
    develop: 'development',
    local: 'local'
  }

  if (!process.env.BUGSNAG_KEY) return

  const releaseStage = mappedReleaseStage[process.env.ENVIRONMENT] || 'development'

  try {
    BugsnagPerformance.start({
      apiKey: process.env.BUGSNAG_KEY,
      appVersion: packageJSON.version,
      releaseStage,
      routingProvider: new VueRouterRoutingProvider(router, '/vendas-client')
    })
  } catch {}
}
